<div class="drag-container" [class.disabled]="disabled()" *transloco="let t">
	<div class="drag-track" #track>
		<div class="drag-progress" [style.width.%]="progress()"></div>

		<div class="drag-label" [class.hidden]="progress() > 30">
			{{ label() || t('billing.dragComplete') }}
		</div>

		<div
			class="drag-handle"
			cdkDrag
			cdkDragBoundary=".drag-track"
			cdkDragLockAxis="x"
			[cdkDragFreeDragPosition]="dragPosition"
			[cdkDragDisabled]="disabled()"
			(cdkDragMoved)="onDragMoved($event)"
			(cdkDragEnded)="onDragEnded($event)">
			<mat-icon>chevron_right</mat-icon>
		</div>
	</div>
</div>
